import HttpService from './HttpService';

const VesselActivityCargoApi = HttpService('/api/vesselActivityCargo/');
const doPost = (action, data) => VesselActivityCargoApi.post(action, data);
const doGet = (url) => VesselActivityCargoApi.get(url);
const doDelete = (url) => VesselActivityCargoApi.delete(url);

export default {
    getVesselActivityCargoForVoyageReport(voyageReportId) {
        const apiAction = 'GetAllVesselActivityCargoForVoyage';
        const queryString = `voyageReportId=${voyageReportId}`;
        const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
        return doGet(fullUrl);
    },
    updateVesselActivityCargos(vesselActivityCargos) {
        const apiAction = 'UpdateVesselActivityCargo';
        return doPost(apiAction, vesselActivityCargos);
    },
    deleteVesselActivityCargos(id) {
      const apiAction = 'DeleteVesselActivityCargoForVesselActivity';
      const queryString = `id=${id}`;
      const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
      return doDelete(fullUrl);
    },
    markAsNob(vesselActivityCargos) {
      const apiAction = 'MarkCargoAsNob';
      return doPost(apiAction, vesselActivityCargos);
  },
  recordExtraLifts(vesselActivityCargos) {
    const apiAction = 'RecordExtraLifts';
    return doPost(apiAction, vesselActivityCargos);
  },
  deleteExtraLift(id) {
    const apiAction = 'DeleteExtraLift';
    const queryString = `id=${id}`;
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doDelete(fullUrl);
  }
};
